import React, { forwardRef } from "react";

import { Action } from "../Action";

export const Handle = forwardRef((props, ref) => {
  const styles = {
    Titulo: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      boxSizing: "border-box",
      minHeight: "20px",
      margin: 0,
      padding: "6px 8px 6px 12px",
      overflow: "hidden",
      borderRadius: "8px",
      boxShadow: "none",
      fontWeight: "600",
      overflowWrap: "break-word",
      fontFamily:
        "Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif",
    },
  };

  return (
    <Action
      ref={ref}
      cursor="grab"
      data-cypress="draggable-handle"
      {...props}
      style={styles.Titulo}
    >
      {props.label}
    </Action>
  );
});
